export default "__VITE_ASSET__9225b3bf__"